import { GraphQLClient } from 'graphql-request';
import { storefrontGraph } from '../../util/config';

const { url, token } = storefrontGraph;

/**
 * @deprecated Going forward features should use Apollo Client located /src/graphql/client
 */
const client = new GraphQLClient(url, {
  headers: {
    'X-Shopify-Storefront-Access-Token': token,
    Accept: 'application/json'
  }
});

export default client;
